import BasePage from "@Scripts/Pages/BasePage";

import LegacyFormHelper from "@Scripts/Infrastructure/LegacyFormHelper";

export default class OrderSupportPage extends BasePage {
    public static async init() {
        await super.init();

        this.setForm();
    }

    private static setForm() {
        var $form = $("#Form"),
            $successBox = $(".success-box-legacy"),
            $formIntro = $(".form-introduction");

        (<any>window).grecaptcha.enterprise.ready(async () => {
            const token = await (<any>window).grecaptcha.enterprise.execute((<any>window).App.bag.recaptchaSiteKey, { action: 'Submit' });

            (<any>$form).ajaxForm({
                iframe: false,
                beforeSubmit: function (formData, jqForm, options) {
                    LegacyFormHelper.disableControls($form);
                    LegacyFormHelper.resetValidation($form);

                    this.headers = { "RecaptchaVerificationToken": token };
                },
                success: function (data) {
                    LegacyFormHelper.resetValidation($form);

                    $form.hide();
                    $formIntro.hide();
                    $successBox.show();
                },
                error: function (xhr, textStatus, errorThrown) {
                    LegacyFormHelper.enableControls($form);
                    LegacyFormHelper.setValidation($form, xhr.responseJSON);
                }
            });
        });
    }
}